
import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductReassurance extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateReassurance);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateReassurance);
  }

  /**
   * Updates the reassurance items.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateReassurance = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newReassurance = event.detail.data.html.querySelector('product-reassurance');

    if (!newReassurance) return;

    morph(this, newReassurance, { childrenOnly: true });
  };
}

if (!customElements.get('product-reassurance')) {
  customElements.define('product-reassurance', ProductReassurance);
}

